import './videoDocumentsRequired.scss';
import React from 'react';
import { connect } from 'react-redux';
import { formatText } from 'core/i18n';
import { VIDEO_CALL } from 'constants/identityMethod';
import {
    COUNTRY_DOCUMENT_TYPE_DNI,
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
    COUNTRY_DOCUMENT_TYPE_PASSPORT,
    COUNTRY_DOCUMENT_TYPE_DA,
    COUNTRY_DOCUMENT_TYPE_PA,
    COUNTRY_DOCUMENT_TYPE_CC,
    COUNTRY_DOCUMENT_TYPE_PP,
    COUNTRY_DOCUMENT_TYPE_DN,
    COUNTRY_DOCUMENT_TYPE_PN,
} from 'constants/multiLanguage';

import { InstructionsList } from './components/InstructionsList';
import DocumentationRequiredHeader from 'components/documentationRequiredHeader/DocumentationRequiredHeader';

const VideoDocumentsRequired = ({
    userProfile: { passport, documentType: userDocumentType, name, videoSelected },
    options,
    withTabs,
}) => {
    const getDocumentAliasByDocumentType = documentType => {
        const reference = {
            [COUNTRY_DOCUMENT_TYPE_DNI]: COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
            [COUNTRY_DOCUMENT_TYPE_DNI_LABEL]: COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
            [COUNTRY_DOCUMENT_TYPE_CC]: COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
            [COUNTRY_DOCUMENT_TYPE_DN]: COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
            [COUNTRY_DOCUMENT_TYPE_DA]: COUNTRY_DOCUMENT_TYPE_DNI_LABEL,

            [COUNTRY_DOCUMENT_TYPE_NIE]: COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
            [COUNTRY_DOCUMENT_TYPE_NIE_LABEL]: COUNTRY_DOCUMENT_TYPE_NIE_LABEL,

            [COUNTRY_DOCUMENT_TYPE_PP]: COUNTRY_DOCUMENT_TYPE_PASSPORT,
            [COUNTRY_DOCUMENT_TYPE_PN]: COUNTRY_DOCUMENT_TYPE_PASSPORT,
            [COUNTRY_DOCUMENT_TYPE_PA]: COUNTRY_DOCUMENT_TYPE_PASSPORT,
            [COUNTRY_DOCUMENT_TYPE_PASSPORT]: COUNTRY_DOCUMENT_TYPE_PASSPORT,
        };

        if (reference[documentType]) return reference[documentType];

        return reference[COUNTRY_DOCUMENT_TYPE_DNI_LABEL];
    };

    const getDocumentationRequiredHeader = () => {
        const documentType = passport
            ? COUNTRY_DOCUMENT_TYPE_PASSPORT
            : getDocumentAliasByDocumentType(userDocumentType);

        return (
            <DocumentationRequiredHeader
                documentType={documentType}
                name={name}
                videoSelected={videoSelected}
                options={options}
                withTabs={withTabs}
            />
        );
    };

    const videoCallContent = () => {
        const documentationRequiredHeader = getDocumentationRequiredHeader();

        return (
            <div className="docs-req">
                {documentationRequiredHeader}
                <InstructionsList
                    instructions={[
                        {
                            title: formatText('identity-videoCallOtherItemsTitle1Desktop'),
                            text: formatText('identity-videoCallOtherItemsDesc1Desktop'),
                        },
                    ]}
                />
            </div>
        );
    };

    const videoSelfieContent = () => {
        const documentationRequiredHeader = getDocumentationRequiredHeader();

        return (
            <div className="docs-req">
                {documentationRequiredHeader}
                <InstructionsList
                    showVideoPermissionAdvise
                    instructions={[
                        {
                            title: formatText('identity-videoSelfieOtherItemsTitle1Desktop'),
                            text: formatText('identity-videoSelfieOtherItemsDesc1Desktop'),
                            hiddenInMobile: true,
                        },
                        {
                            title: formatText('identity-videoSelfieOtherItemsTitle2Desktop'),
                            text: formatText('identity-videoSelfieOtherItemsDesc2Desktop'),
                        },
                        {
                            title: formatText('identity-videoSelfieOtherItemsTitle3Desktop'),
                            text: formatText('identity-videoSelfieOtherItemsDesc3Desktop'),
                        },
                    ]}
                />
            </div>
        );
    };

    return videoSelected === VIDEO_CALL ? videoCallContent() : videoSelfieContent();
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        options: state.options,
    }),
    null
)(VideoDocumentsRequired);
